import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { getActiveCreditsAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";

// `onValor` avisa al panel el total, que usa el indicador de vencidos para su porcentaje.
const ActiveCredits = ({ onValor }) => {
  const [activeCredits, setActiveCredits] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getActiveCreditsAsync,
    (data) => {
      setActiveCredits(data.result);
      onValor?.(data.result);
    }
  );

  return (
    <KpiPanel
      titulo="Créditos Activos"
      valor={activeCredits}
      formato="entero"
      icono={
        <FontAwesomeIcon icon={faHandHoldingDollar} style={{ fontSize: 22 }} />
      }
      tono="primary"
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino="/credits"
      permiso="CREDITS VER"
      ayuda="Ver Créditos"
    />
  );
};

export default ActiveCredits;
